module.exports = __webpack_public_path__ + "img/integrately.e403e7e5.png";